import React from "react"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import { grey500 } from "material-ui/styles/colors"
import { IHierarchyItemForAccountLevel, IHierarchyItem, IJobDocument } from "../../../models"
import HierarchyJobVariationsDialog from "./HierarchyJobVariationsDialog"

interface IProps {
    settingPropertyName: string
    hierarchyJobItem: IHierarchyItemForAccountLevel | IHierarchyItem | IJobDocument
    inheritedHierarchyJobItem: IHierarchyItem | IJobDocument
}
interface IState {
    openDialog: boolean
}

export default class HierarchyJobVariations extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openDialog: false
        }
        autobind(this)
    }

    render() {
        if (this.props.hierarchyJobItem.hasOwnProperty("AccountId")) return null
        let hierarchyJobItemId = this.props.hierarchyJobItem ? (this.props.hierarchyJobItem as IHierarchyItem).Id : null
        hierarchyJobItemId = hierarchyJobItemId ? hierarchyJobItemId : null
        let inheritedHierarchyJobItemId = this.props.inheritedHierarchyJobItem ? this.props.inheritedHierarchyJobItem.Id : null
        inheritedHierarchyJobItemId = inheritedHierarchyJobItemId ? inheritedHierarchyJobItemId : null
        if (hierarchyJobItemId !== inheritedHierarchyJobItemId) return null
        return (
            <span
                style={{ borderBottom: "1px solid", borderBottomColor: grey500, cursor: "pointer", marginLeft: 20 }}
                onClick={e => {
                    e.stopPropagation()
                    this.setState({ openDialog: true })
                }}
            >
                {strings.Hierarchy_Job_Variations}
                {this.state.openDialog &&
                    <HierarchyJobVariationsDialog
                        settingPropertyName={this.props.settingPropertyName}
                        hierarchyId={hierarchyJobItemId}
                        handleClose={() => this.setState({ openDialog: false })}
                    />
                }
            </span>
        )
    }
}